import React, { useEffect, useState } from "react";
import { useGoogleOneTapLogin } from "@react-oauth/google";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { safeLocalStorage as localStorage, safeSessionStorage as sessionStorage } from "@/lib/safeStorage";

const shortViewport = () => {
  const viewport = window.visualViewport;
  return ((viewport?.width || window.innerWidth) <= 900 || window.matchMedia("(pointer: coarse)").matches) && (viewport?.height || window.innerHeight) <= 500;
};

// Accesso Google automatico (One Tap): mostra un prompt "Continua come X" quando
// l'utente non è loggato. 1 solo click, senza popup completo. Safety-net cross-domain.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function GoogleOneTapAutoLogin() {
  const { user, autoLoginSuppressed } = useAuth();
  const location = useLocation();
  const [compact, setCompact] = useState(shortViewport);
  useEffect(() => {
    const update = () => { const short = shortViewport(); setCompact(short); if (short) window.google?.accounts?.id?.cancel(); };
    window.addEventListener("resize", update);
    window.visualViewport?.addEventListener("resize", update);
    return () => { window.removeEventListener("resize", update); window.visualViewport?.removeEventListener("resize", update); };
  }, []);
  const loggedOut = typeof window !== "undefined" && sessionStorage.getItem("rv_logged_out") === "1";

  useGoogleOneTapLogin({
    disabled: user !== false || loggedOut || compact || autoLoginSuppressed || location.pathname !== "/" || new URLSearchParams(location.search).get("google") === "link", // solo quando ospite (false), non in caricamento (null) né loggato
    auto_select: true,
    cancel_on_tap_outside: true,
    onSuccess: async (credentialResponse) => {
      try {
        const { data } = await api.post("/auth/google/onetap", { credential: credentialResponse.credential });
        if (data && data.twofa_required) {
          sessionStorage.setItem("markoo_2fa", JSON.stringify(data));
          window.location.href = "/";
          return;
        }
        if (data && data.access_token) localStorage.setItem("rv_token", data.access_token);
        window.location.reload();
      } catch (error) {
        const detail = formatApiErrorDetail(error.response?.data?.detail);
        sessionStorage.setItem("rv_logged_out", "1");
        window.google?.accounts?.id?.cancel();
        if (error.response?.status === 403) toast.error(detail);
      }
    },
    onError: () => {},
  });

  return null;
}
